const allOptions = [
    {
        // General information
        TableName: "Warehouse\\Products",
        DisplayName: "Producten",

        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "Warehouse\\Products": [ // Primary table
                "product_name",
                "product_number",
                "product_description",
                "status",
                "type",
                "supplier_id",
                "head_product_id",
                "image",
            ],
            
            // Sub tables
            "Warehouse\\Barcodes": [
                "barcode"
            ],

            // Custom fields that are not in the database and be customly handled in the backend
            "CUSTOM_FIELDS": [
                "stock_amount",
                "purchase_price",
                "sell_price_excl",
                "sell_price_incl",
                "sale_price_excl",
                "sale_price_incl",
                "category",
                "season",
                "vat_rate",
                "style_number",
                "size",
                "color",
                "color_hex",
                "gender",
                "brand",
            ]
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            product_name: "Product naam",
            product_number: "Product nummer",
            product_description: "Product omschrijving",
            status: "Status",
            type: "Type",
            supplier_id: "Leverancier ID",
            head_product_id: "Hoofdproduct ID",
            barcode: "Barcode",
            image: "Afbeelding",

            // Custom fields
            stock_amount: "Voorraad",
            purchase_price: "Inkoopprijs",
            sell_price_excl: "Verkoop prijs (excl btw)",
            sell_price_incl: "Verkoop prijs (incl btw)",
            sale_price_excl: "Kortingsprijs (excl btw)",
            sale_price_incl: "Kortingsprijs (incl btw)",
            vat_rate: "BTW tarief",
            style_number: "Stijlnummer",
            size: "Maat",
            color: "Kleur",
            color_hex: "Kleur (Hexcode)",
            gender: "Geslacht",
            category: "Categorie",
            season: "Seizoen",
            brand: "Merk",
        },

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Warehouse\\Products": ["product_number"],
            "Warehouse\\Barcodes": ["barcode"],
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["product_name"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/producten/bewerken", // Url of the edit/view page 
        },

        // Foreign key among all the tables
        SharedId: "product_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["product_name"],
    },
    {
        // General information
        TableName: "Client\\Consumers",
        DisplayName: "Customers",

        // Columns in the database with their index being the model in the api
        TableColumns: {
            "Client\\Consumers": [ // Primary table
                "prefix",
                "first_name",
                "last_name",
                "birthday",
                "language",
                "fax_number",
                "loyalty_points",
                "has_loyalty",
            ],

            "Client\\PhoneNumbers": [ // Sub table
                "phone_number",
            ],
            
            // Sub tables
            Emails: ["email"],
            EmailSettings: ["newsletter"],

            // Custom fields that are not in the database and be customly handled in the backend
            "CUSTOM_FIELDS": [
                "infix",
                "delivery_city",
                "delivery_streetname",
                "delivery_housenumber",
                "delivery_addition",
                "delivery_postalcode",
                "delivery_country",
                "invoice_city",
                "invoice_streetname",
                "invoice_housenumber",
                "invoice_addition",
                "invoice_postalcode",
                "invoice_country",
            ]
        },

        // Foreign key among all the tables
        SharedId: "internal_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["first_name", "last_name", "email"],

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Emails": ["email"]
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["first_name", "last_name"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/klanten/bewerken", // Url of the edit/view page 
        },

        // User-friendly display names for columns
        DisplayNames: {
            prefix: "Voorvoegsel",
            first_name: "Voornaam",
            infix: "Tussenvoegsel",
            last_name: "Achternaam",
            phone_number: "Telefoonnummer",
            birthday: "Geboortedatum",
            language: "Taal",
            fax_number: "Faxnummer",
            loyalty_points: "Loyaltypunten",
            email: "E-mail",
            city: "Stad",
            streetname: "Straatnaam",
            housenumber: "Huisnummer",
            addition: "Toevoeging",
            postalcode: "Postcode",
            has_loyalty: "Heeft loyaliteit",
            newsletter: "Nieuwsbrief",

            // Custom fields
            delivery_city: "Bezorg stad",
            delivery_streetname: "Bezorg straatnaam",
            delivery_housenumber: "Bezorg huisnummer",
            delivery_addition: "Bezorg toevoeging",
            delivery_postalcode: "Bezorg postcode",
            delivery_country: "Bezorg land",
            invoice_city: "Factuur stad",
            invoice_streetname: "Factuur straatnaam",
            invoice_housenumber: "Factuur huisnummer",
            invoice_addition: "Factuur toevoeging",
            invoice_postalcode: "Factuur postcode",
            invoice_country: "Factuur land",
        },
    },
    {
        // General information
        TableName: "Warehouse\\ProductCategories",
        DisplayName: "Categorieën",

        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "Warehouse\\ProductCategories": [ // Primary table
                "title",
                "slug",
                "image",
                "description",
                "status",
                "sorting_order",
            ],

            // Custom fields that are not in the database and be customly handled in the backend
            "CUSTOM_FIELDS": [
                "sub_category_1",
                "sub_category_2",
                "sub_category_3",
                "sub_category_4",
                "sub_category_5",
                "sub_category_6",
                "sub_category_7",
                "sub_category_8",
                "sub_category_9",
                "sub_category_10",
            ]
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            title: "Titel",
            slug: "Slug",
            image: "Afbeelding",
            description: "Omschrijving",
            status: "Status",
            sorting_order: "Sorteervolgorde",

            // Custom fields
            sub_category_1: "Subcategorie 1",
            sub_category_2: "Subcategorie 2",
            sub_category_3: "Subcategorie 3",
            sub_category_4: "Subcategorie 4",
            sub_category_5: "Subcategorie 5",
            sub_category_6: "Subcategorie 6",
            sub_category_7: "Subcategorie 7",
            sub_category_8: "Subcategorie 8",
            sub_category_9: "Subcategorie 9",
            sub_category_10: "Subcategorie 10",
        },

        // Foreign key among all the tables
        SharedId: "category_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["title"],

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Warehouse\\ProductCategories": ["title"],
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["title"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/algemene/instellingen/product/categorieën/bewerken", // Url of the edit/view page
        },
    },
    {
        // General information
        TableName: "Warehouse\\ProductSizes",
        DisplayName: "Maten",
        
        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "Warehouse\\ProductSizes": [ // Primary table
                "status",
                "main",
                "sorting_order",
            ],
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            status: "Status",
            main: "Maat",
            sorting_order: "Sorteervolgorde",
        },

        // Foreign key among all the tables
        SharedId: "size_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["main"],

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Warehouse\\ProductSizes": ["main"],
        },
        
        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["main"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/algemene/instellingen/product/maten/bewerken", // Url of the edit/view page
        },
    },
    {
        // General information
        TableName: "Warehouse\\ProductColors",
        DisplayName: "Kleuren",

        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "Warehouse\\ProductColors": [ // Primary table
                "status",
                "name",
                "hex",
            ]
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            status: "Status",
            name: "Naam",
            hex: "Hexcode",
        },

        // Foreign key among all the tables
        SharedId: "color_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["name"],
        
        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Warehouse\\ProductColors": ["name"],
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["name"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/algemene/instellingen/product/kleuren/bewerken", // Url of the edit/view page
        },      
    },
    {
        // General information
        TableName: "Warehouse\\ProductBrands",
        DisplayName: "Merken",

        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "Warehouse\\ProductBrands": [ // Primary table
                "name",
                "description",
                "status",
            ]
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            name: "Naam",
            description: "Beschrijving",
            status: "Status",
        },

        // Foreign key among all the tables
        SharedId: "brand_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["name"],

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Warehouse\\ProductBrands": ["name"],
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["name"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/algemene/instellingen/product/merken/bewerken", // Url of the edit/view page
        },
    },
    {
        // General information
        TableName: "Giftcards",
        DisplayName: "Cadeaukaarten",

        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "Giftcards": [ // Primary table
                "card_number",
                "pin",
                "balance",
                "status",
                "created_at",
                "expiry_date",
            ]
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            card_number: "Kaartnummer",
            pin: "PIN",
            balance: "Saldo",
            status: "Status",
            created_at: "Aangemaakt op",
            expiry_date: "Verval datum",
        },

        // Foreign key among all the tables
        SharedId: "card_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["card_number", "balance"],

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "Giftcards": ["card_number"],
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["card_number"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/cadeaukaarten/bewerken", // Url of the edit/view page
        },
    },
    {
        // General information
        TableName: "BackofficeSettings",
        DisplayName: "bedrijfs informatie",

        // Columns in the database with their index being the model in the api and the string values in the array being the column names in the database
        TableColumns: {
            "BackofficeSettings": [ // Primary table
                "company_name",
                "street_name",
                "house_number",
                "addition",
                "postal_code",
                "city",
                "province",
                "phone_number",
                "email",
                "website",
                "start_invoicenumber",
                "payment_term",
                "invoice_description",
                "payment_description",
                "invoicemail",
                "invoice_streetname",
                "invoice_house_number",
                "invoice_addition",
                "invoice_postalcode",
                "invoice_city",
                "begin_workday",
                "end_workday",
                "vatnumber",
                "cocnumber",
                "bank",
                "iban",
                "bic",
                "default_product_tax",
                "default_shipping_tax",
                "default_payment_tax",
            ],

            // Custom fields that are not in the database and be customly handled in the backend
            "CUSTOM_FIELDS": [
                "country",
            ]
        },

        // User-friendly display names for columns that are in TableColumns
        DisplayNames: {
            company_name: "Bedrijfsnaam",
            street_name: "Straatnaam",
            house_number: "Huisnummer",
            addition: "Toevoeging",
            postal_code: "Postcode",
            city: "Stad",
            province: "Provincie",
            phone_number: "Telefoonnummer",
            email: "E-mail",
            website: "Website",
            start_invoicenumber: "Start factuurnummer",
            payment_term: "Betalingstermijn",
            invoice_description: "Factuuromschrijving",
            payment_description: "Betalingsomschrijving",
            invoicemail: "Factuur e-mail",
            invoice_streetname: "Factuur straatnaam",
            invoice_house_number: "Factuur huisnummer",
            invoice_addition: "Factuur toevoeging",
            invoice_postalcode: "Factuur postcode",
            invoice_city: "Factuur stad",
            begin_workday: "Begin werkdag",
            end_workday: "Einde werkdag",
            vatnumber: "BTW nummer",
            cocnumber: "KvK nummer",
            bank: "Bank",
            iban: "IBAN",
            bic: "BIC",
            default_product_tax: "Standaard product BTW",
            default_shipping_tax: "Standaard verzend BTW",
            default_payment_tax: "Standaard betaal BTW",

            // Custom fields
            country: "Land",
        },

        // Foreign key among all the tables
        SharedId: "setting_id",

        // Columns that are required in order to process the import
        RequiredColumns: ["company_name", "email"],

        // Keys which can be used as leading key for updating.
        UpdateKeys: {
            "BackofficeSettings": ["company_name"],
        },

        // Display information to direct the user to the object that has been made
        DirectInfo: {
            displayValues: ["company_name"], // Values that will be displayed as the object, when multiple it will have a space between
            url: "/algemene/instellingen/bedrijfsinformatie/algemeen", // Url of the edit/view page
        },
    }
];

export default allOptions;